import RestClient from './rest-client';
import { getConfig } from '../config/envConfig';

class OAuthClient extends RestClient {
  revokeRefreshToken(oauthClientId: string): Promise<void> {
    return this.postResource(`/refreshTokens/user/${oauthClientId}/revoke`);
  }
}

export const oAuthClient = new OAuthClient({
  serviceUrl: `${getConfig().stargateRoot}/oauth`,
});
